import { Link } from 'react-router-dom'
import { ArrowRight, Clock, User } from 'lucide-react'
import SEO from '../components/SEO'
import './Blogs.css'

const posts = [
  { title: 'Why Indian SMEs are Moving Away from Spreadsheet Payroll', excerpt: 'Manual payroll processing costs companies more than just time. We break down the real cost of errors, audit risks, and compliance gaps when payroll lives in Excel.', category: 'HCM', date: 'June 5, 2025', author: 'Priya Raghunathan', read: '6 min read' },
  { title: 'GST e-Invoicing: What Every Business Needs to Know in 2025', excerpt: 'The GSTN mandate has expanded. Here\'s a plain-English guide to e-invoice generation, IRN, QR codes, and how to automate the process from your accounting software.', category: 'Accounting', date: 'May 22, 2025', author: 'Venkat Subramanian', read: '8 min read' },
  { title: 'Building a High-Performance Culture: OKRs vs KPIs in Indian Enterprises', excerpt: 'Both frameworks promise better performance. We compare OKRs and KPIs on clarity, adaptability, and measurability — and suggest when to use which.', category: 'HCM', date: 'May 10, 2025', author: 'Aditi Sharma', read: '5 min read' },
  { title: 'Reducing Food Waste in Cloud Kitchens with Smart Inventory Management', excerpt: 'Cloud kitchens operate on thin margins. Discover how recipe-level inventory deduction and wastage tracking can improve food cost percentage by 8–12%.', category: 'F&B', date: 'April 28, 2025', author: 'Rajan Krishnan', read: '5 min read' },
  { title: 'Tirupur\'s Textile Exporters and the Digital Traceability Mandate', excerpt: 'Global buyers increasingly demand supply chain transparency. Learn how lot-wise traceability in Textile ERP helps Tirupur mills win and retain international contracts.', category: 'Textile', date: 'April 12, 2025', author: 'Muthukumar S.', read: '7 min read' },
  { title: 'How MRP Systems Prevent the ₹50 Lakh Inventory Problem', excerpt: 'Overstocking and stockouts — manufacturers often suffer both simultaneously. We explain how automated MRP runs eliminate this paradox with real customer data.', category: 'Manufacturing', date: 'March 30, 2025', author: 'Deepa Nair', read: '6 min read' },
]

const cats = ['All', 'HCM', 'Accounting', 'F&B', 'Textile', 'Manufacturing']

export default function Blogs() {
  return (
    <>
      <SEO title="Blog – Insights & Resources" description="Expert articles on HR technology, GST compliance, restaurant management, textile ERP, and manufacturing from the NexCore team." keywords="HR technology blog, GST compliance guide, restaurant POS tips, textile ERP, manufacturing ERP India" path="/blogs" />
      <section className="page-hero">
        <div className="container">
          <p className="section-label">Insights</p>
          <h1 className="section-title">Ideas from the NexCore team</h1>
          <p className="section-subtitle">Practical guides, industry trends, and expert perspectives on enterprise software and the sectors we serve.</p>
        </div>
      </section>

      <section className="blogs-section">
        <div className="container">
          <div className="blogs-cats">
            {cats.map(c => <button key={c} className={`blogs-cat ${c === 'All' ? 'blogs-cat--active' : ''}`}>{c}</button>)}
          </div>
          <div className="blogs-grid">
            {posts.map(post => (
              <div key={post.title} className="blog-card">
                <div className="blog-card__top">
                  <span className="blog-card__cat">{post.category}</span>
                </div>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
                <div className="blog-card__meta">
                  <span><User size={13} /> {post.author}</span>
                  <span><Clock size={13} /> {post.read}</span>
                  <span>{post.date}</span>
                </div>
                <button className="blog-card__read">Read Article <ArrowRight size={14} /></button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
